import type React from "react";

import { Menu } from "lucide-react";

import { Brand } from "./brand";
import { MainMenu } from "./mainmenu";

export const HeaderBar: React.FC = () => {
  return (
    <nav className="dui-navbar bg-base-300 shadow-sm md:px-8">
      <div className="dui-navbar-start">
        <div className="dui-dropdown">
          <div tabIndex={0} role="button" className="dui-btn dui-btn-ghost lg:hidden">
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" />
            </svg> */}
            <Menu />
          </div>
          <ul className="dui-menu dui-menu-sm dui-dropdown-content bg-base-100 rounded-box z-1 mt-3 w-52 p-2 shadow">
            <MainMenu />
          </ul>
        </div>

        <Brand />
      </div>
      <div className="dui-navbar-end hidden lg:flex">
        <ul className="dui-menu dui-menu-horizontal px-1">
          <MainMenu />
        </ul>
      </div>
    </nav>
  );
};
